import type { PaymentIntent } from '@stripe/stripe-js';

import { isFreeTrialPlanCode } from 'app/network/plan';

export type PaymentIntentAction = 'wait-for-plan' | 'payment-pending' | 'retry-payment-method' | 'show-error';

export function isWebPaymentEligible(planCode: string | null | undefined, isCorePartageClub: boolean): boolean {
  return isCorePartageClub && isFreeTrialPlanCode(planCode);
}

export function getPaymentIntentAction(status: PaymentIntent.Status): PaymentIntentAction {
  if (status === 'succeeded') return 'wait-for-plan';
  if (status === 'processing') return 'payment-pending';
  if (status === 'requires_payment_method') return 'retry-payment-method';
  return 'show-error';
}

export function buildPaymentReturnUrl(currentUrl: string): string {
  const returnUrl = new URL(currentUrl);
  returnUrl.search = '';
  returnUrl.hash = '';
  return returnUrl.toString();
}

export function calculatePaymentTotal(amount: number, taxesPercentage: number): number {
  return Math.round(amount * (1 + taxesPercentage));
}

export async function pollForPaidPlan(
  fetchLatestPlanCode: () => Promise<string | null | undefined>,
  attempts: number,
  intervalMs: number,
): Promise<boolean> {
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    const planCode = await fetchLatestPlanCode();
    if (planCode && !isFreeTrialPlanCode(planCode)) return true;
    if (attempt < attempts - 1) await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return false;
}
